import { Switch } from "../../../components/ui/switch";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";
import { EXIT_POPUP_DEFAULTS } from "../../../components/landing/ExitIntentPopup";

export default function ExitPopupCard({ settings, patchSettings, Card }) {
  const enabled = settings.exitPopupEnabled !== false;
  return (
    <Card testid="settings-exit-popup-card">
      <h3 className="font-serif text-xl text-stone-900">"Before you go" pop-up</h3>
      <p className="mt-1 text-sm text-stone-500">Shows once per visit when someone is about to leave (mouse heads for the browser bar on desktop, or a quick scroll back up on phones). Gives them a last nudge to book or call.</p>
      <label className="mt-5 flex items-center justify-between gap-4 text-sm font-medium text-stone-700">
        <span>Show the pop-up on the website</span>
        <Switch checked={enabled} onCheckedChange={(v) => patchSettings({ exitPopupEnabled: v })} data-testid="exit-popup-enabled-switch" />
      </label>
      <div className={`mt-5 space-y-4 ${enabled ? "" : "opacity-60"}`}>
        <div>
          <Label>Headline</Label>
          <Input className="mt-1.5" value={settings.exitPopupTitle || ""} onChange={(e) => patchSettings({ exitPopupTitle: e.target.value })} placeholder={EXIT_POPUP_DEFAULTS.exitPopupTitle} data-testid="exit-popup-title-input" />
        </div>
        <div>
          <Label>Message</Label>
          <Textarea className="mt-1.5" rows={3} value={settings.exitPopupText || ""} onChange={(e) => patchSettings({ exitPopupText: e.target.value })} placeholder={EXIT_POPUP_DEFAULTS.exitPopupText} data-testid="exit-popup-text-input" />
        </div>
        <div>
          <Label>Button label</Label>
          <Input className="mt-1.5" value={settings.exitPopupButton || ""} onChange={(e) => patchSettings({ exitPopupButton: e.target.value })} placeholder={EXIT_POPUP_DEFAULTS.exitPopupButton} data-testid="exit-popup-button-input" />
          <p className="mt-1 text-xs text-stone-400">The button jumps to the booking form. Your phone number is shown as a second button automatically. Leave fields blank to use the suggested wording.</p>
        </div>
      </div>
    </Card>
  );
}
